import { isPromise } from "./promise.js";
const reduceHelper = (reducer, s, xs, firstIndex) => {
    let current = s;
    for (let i = firstIndex; i < xs.length; i++) {
        if (isPromise(current)) {
            return current.then((s) => reduceHelper(reducer, s, xs, i));
        }
        current = reducer(current, xs[i]);
    }
    return current;
};
// deno-lint-ignore no-explicit-any
export const reduce = (reducer, initial) => (xs) => reduceHelper(reducer, initial(), xs, 0);
export const min = (key) => (xs) => reduceHelper((s, x) => {
    const keyS = key(s);
    const keyX = key(x);
    return ((isPromise(keyS) || isPromise(keyX))
        ? Promise.all([keyS, keyX]).then(([keyS, keyX]) => keyS < keyX ? s : x)
        : key(s) < key(x)
            ? s
            : x);
}, xs[0], xs, 1);
export const max = (key) => (xs) => reduceHelper((s, x) => {
    const keyS = key(s);
    const keyX = key(x);
    return ((isPromise(keyS) || isPromise(keyX))
        ? Promise.all([keyS, keyX]).then(([keyS, keyX]) => keyS < keyX ? x : s)
        : key(s) < key(x)
            ? x
            : s);
}, xs[0], xs, 1);
